import {
  Component,
  Input,
  Output,
  EventEmitter,
  ChangeDetectionStrategy,
  ViewEncapsulation,
  SimpleChanges,
  OnChanges,
  ChangeDetectorRef,
  Renderer2,
  AfterViewInit,
  TemplateRef,
} from '@angular/core';
import { Router } from '@angular/router';
import { PhxOmniOption } from '../phx-omni-search-filter.types';
import { PhxTranslatePipe } from '../../../translation/phx-translation.pipe';
import { PhxSelectOption } from '../../select/select.types';
import { PhxOmniBaseComponent } from '../phx-omni-base.component';
import { PhxBreakpointObserverService } from '../../../services/phx-breakpoint-service';
import { MagnifyingGlass } from '../../icon/icon-map';

@Component({
  selector: 'phx-omnisearch',
  templateUrl: './phx-omnisearch.component.html',
  styleUrls: ['./phx-omnisearch.component.scss'],
  host: { class: 'phx-omnisearch', role: 'search', '[class.phx-omnisearch-disabled]': 'phxDisabled' },
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class PhxOmnisearchComponent extends PhxOmniBaseComponent implements OnChanges, AfterViewInit {
  @Input() phxPlaceholder: string = 'Search entities';
  @Input() phxTriggerCollapsed: boolean = false;
  @Input() phxSecondaryTrigger: boolean = false;
  @Input() phxTriggerTemplate: TemplateRef<any>;
  @Input() phxShowGroupByToggle: boolean = false;

  @Output() phxItemClick: EventEmitter<PhxOmniOption> = new EventEmitter<PhxOmniOption>();

  public isMobile: boolean = false;
  public isOpen: boolean = false;
  public dropdownOffset: { x: number; y: number } = { x: 16, y: 0 };
  public readonly MagnifyingGlassIcon = MagnifyingGlass;

  constructor(renderer: Renderer2, cdr: ChangeDetectorRef, phxTranslate: PhxTranslatePipe, private _phxBreakpointObserver: PhxBreakpointObserverService, private _router: Router) {
    super(renderer, cdr, phxTranslate);
    this.setDerivedComponentName('PhxOmnisearchComponent');
  }

  ngOnChanges(changes: SimpleChanges): void {
    super.ngOnChanges(changes);

    const { phxTriggerCollapsed } = changes;

    if (phxTriggerCollapsed) {
      this.dropdownOffset = phxTriggerCollapsed.currentValue ? { x: 12, y: 0 } : { x: 16, y: 0 };
    }
  }

  ngAfterViewInit(): void {
    this._phxBreakpointObserver.smMobile.subscribe((isMobile: boolean) => {
      this.isMobile = isMobile;
    });
  }

  public onItemClick(option: PhxSelectOption): void {
    const omniOption = this.transformToOmniOption(option);
    const navigationLink = this.phxDomains[omniOption.domain]?.navigateTo(omniOption);
    this._router.navigate(navigationLink);
    this.phxItemClick.emit(omniOption);
    this.onSearchClear();

    if (this.isMobile) {
      this.isOpen = false;
      this._cdr.detectChanges();
    }
  }

  public onTriggerClick(): void {
    if (this.isMobile) {
      this.isOpen = true;
    }
  }

  public onOpenChange(isOpen: boolean): void {
    if (!isOpen) {
      this.onSearchClear();
    }
  }
}
